import React from 'react';

export default function News() {
  return <h2>Benvenuto nella pagina Novità</h2>;
}